import { Map } from 'immutable'
import { createSelector } from 'reselect'

const getLogoutState = (state: Map<string, any>) => state?.get('logout')

export const getIsSessionTimedOut = createSelector(getLogoutState, (logout) => logout.get('isSessionTimedOut'))

export const getIsLogoutInProgress = createSelector(getLogoutState, (logout) => logout.get('isLogoutInProgress'))
